import { render, staticRenderFns } from "./website-top.vue?vue&type=template&id=f8de02da&scoped=true"
import script from "./website-top.vue?vue&type=script&lang=js"
export * from "./website-top.vue?vue&type=script&lang=js"
import style0 from "./website-top.vue?vue&type=style&index=0&id=f8de02da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de02da",
  null
  
)

export default component.exports